import { getMePreferences } from '../staff/preferences';
import { OpenClosingTimeOptions } from './systemSettings.types';

export const useOpenClosingTimePref = () => {
  const prefs = getMePreferences();
  return prefs ? prefs.personalization.openClosingTimes : OpenClosingTimeOptions.all;
};
